var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45849 -6.10352e-05C5.48038 -6.10352e-05 3.58328 0.785742 2.18454 2.18448C0.785803 3.58322 0 5.48032 0 7.45843C0 9.43654 0.785803 11.3336 2.18454 12.7324C3.58328 14.1311 5.48038 14.9169 7.45849 14.9169C9.07582 14.9169 10.639 14.3916 11.9199 13.4355L16.17 17.6862C16.5884 18.1046 17.2667 18.1047 17.6851 17.6863C18.1035 17.268 18.1035 16.5897 17.6852 16.1713L13.435 11.9205C14.3915 10.6395 14.917 9.07605 14.917 7.45843C14.917 5.48032 14.1312 3.58322 12.7324 2.18448C11.3337 0.785742 9.43661 -6.10352e-05 7.45849 -6.10352e-05ZM11.2485 11.186C12.2259 10.1922 12.7744 8.85357 12.7744 7.45843C12.7744 6.04857 12.2143 4.69646 11.2174 3.69954C10.2205 2.70262 8.86835 2.14256 7.45849 2.14256C6.04863 2.14256 4.69652 2.70262 3.6996 3.69954C2.70268 4.69646 2.14262 6.04857 2.14262 7.45843C2.14262 8.86829 2.70268 10.2204 3.6996 11.2173C4.69652 12.2142 6.04863 12.7743 7.45849 12.7743C8.85343 12.7743 10.1918 12.226 11.1856 11.2488C11.1956 11.238 11.2059 11.2273 11.2164 11.2168C11.2269 11.2062 11.2376 11.196 11.2485 11.186Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.4bb4c2eda7c2ad8e6985665719478b53.svg";
export { ForwardRef as ReactComponent };